import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import { sendNewsLetterEmail } from "utils/apiUtil";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import Heading from "components/Heading/Heading";
import FAQ from "components/FAQ/FAQ";

export interface PageContactProps {
  className?: string;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.25 4.50006C8.84674 4.50006 9.41903 4.73711 9.84099 5.15907C10.2629 5.58103 10.5 6.15332 10.5 6.75006C10.5 6.94897 10.579 7.13974 10.7197 7.28039C10.8603 7.42104 11.0511 7.50006 11.25 7.50006C11.4489 7.50006 11.6397 7.42104 11.7803 7.28039C11.921 7.13974 12 6.94897 12 6.75006C12 5.7555 11.6049 4.80167 10.9017 4.09841C10.1984 3.39515 9.24456 3.00006 8.25 3.00006C8.05109 3.00006 7.86032 3.07908 7.71967 3.21973C7.57902 3.36038 7.5 3.55115 7.5 3.75006C7.5 3.94897 7.57902 4.13974 7.71967 4.28039C7.86032 4.42104 8.05109 4.50006 8.25 4.50006Z" fill="#AD0419" />
        <path d="M8.25 1.50012C9.64239 1.50012 10.9777 2.05325 11.9623 3.03781C12.9469 4.02238 13.5 5.35774 13.5 6.75012C13.5 6.94903 13.579 7.1398 13.7197 7.28045C13.8603 7.4211 14.0511 7.50012 14.25 7.50012C14.4489 7.50012 14.6397 7.4211 14.7803 7.28045C14.921 7.1398 15 6.94903 15 6.75012C15 4.95991 14.2888 3.24302 13.023 1.97715C11.7571 0.711281 10.0402 0.00012207 8.25 0.00012207C8.05109 0.00012207 7.86032 0.0791397 7.71967 0.219792C7.57902 0.360444 7.5 0.55121 7.5 0.750122C7.5 0.949034 7.57902 1.1398 7.71967 1.28045C7.86032 1.4211 8.05109 1.50012 8.25 1.50012Z" fill="#AD0419" />
        <path d="M14.8125 10.4325C14.7712 10.3121 14.7 10.2042 14.6056 10.1189C14.5111 10.0336 14.3965 9.97376 14.2725 9.945L9.7725 8.9175C9.65035 8.8898 9.52321 8.89314 9.40269 8.9272C9.28216 8.96126 9.17208 9.02497 9.0825 9.1125C8.9775 9.21 8.97 9.2175 8.4825 10.1475C6.8649 9.40212 5.56875 8.10064 4.83 6.48C5.7825 6 5.79 6 5.8875 5.8875C5.97503 5.79792 6.03874 5.68784 6.0728 5.56731C6.10686 5.44678 6.11019 5.31965 6.0825 5.1975L5.055 0.75C5.02623 0.626022 4.96639 0.511403 4.88111 0.416934C4.79582 0.322464 4.6879 0.251252 4.5675 0.21C4.39235 0.147442 4.21148 0.102225 4.0275 0.0749999C3.83794 0.0310464 3.6445 0.00592451 3.45 0C2.535 0 1.65748 0.363481 1.01048 1.01048C0.363481 1.65748 0 2.535 0 3.45C0.00396894 6.51203 1.22211 9.44751 3.3873 11.6127C5.55248 13.7779 8.48797 14.996 11.55 15C12.0031 15 12.4517 14.9108 12.8703 14.7374C13.2888 14.564 13.6692 14.3099 13.9895 13.9895C14.3099 13.6692 14.564 13.2888 14.7374 12.8703C14.9108 12.4517 15 12.0031 15 11.55C15.0002 11.3591 14.9852 11.1685 14.955 10.98C14.9235 10.7937 14.8758 10.6105 14.8125 10.4325ZM11.55 13.5C8.88518 13.498 6.33008 12.4385 4.44577 10.5542C2.56146 8.66992 1.50199 6.11482 1.5 3.45C1.50198 2.93344 1.70806 2.43859 2.07332 2.07332C2.43859 1.70806 2.93344 1.50198 3.45 1.5H3.6975L4.5 4.98L4.095 5.19C3.45 5.5275 2.94 5.7975 3.21 6.3825C3.64967 7.62718 4.36108 8.7583 5.29255 9.69366C6.22402 10.629 7.35216 11.3451 8.595 11.79C9.225 12.045 9.4725 11.5725 9.81 10.92L10.0275 10.5075L13.5 11.3025V11.55C13.498 12.0666 13.2919 12.5614 12.9267 12.9267C12.5614 13.2919 12.0666 13.498 11.55 13.5Z" fill="#AD0419" />
      </svg>


    ),
    title: "Phone Number",
    detail: globalJson.phone,
  },
  {
    id: 2,
    icon: (
      <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.75 6H3.25C2.65326 6 2.08097 6.23705 1.65901 6.65901C1.23705 7.08097 1 7.65326 1 8.25V15.75C1 16.3467 1.23705 16.919 1.65901 17.341C2.08097 17.7629 2.65326 18 3.25 18H13.75C14.3467 18 14.919 17.7629 15.341 17.341C15.7629 16.919 16 16.3467 16 15.75V8.25C16 7.65326 15.7629 7.08097 15.341 6.65901C14.919 6.23705 14.3467 6 13.75 6ZM13.2475 7.5L8.5 11.0625L3.7525 7.5H13.2475ZM13.75 16.5H3.25C3.05109 16.5 2.86032 16.421 2.71967 16.2803C2.57902 16.1397 2.5 15.9489 2.5 15.75V8.4375L8.05 12.6C8.17982 12.6974 8.33772 12.75 8.5 12.75C8.66228 12.75 8.82018 12.6974 8.95 12.6L14.5 8.4375V15.75C14.5 15.9489 14.421 16.1397 14.2803 16.2803C14.1397 16.421 13.9489 16.5 13.75 16.5Z" fill="#AD0419" />
      </svg>


    ),
    title: "Email",
    detail: globalJson.email,
  },
  {
    id: 3,
    icon: (
      <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99948 5.69257C8.34443 5.69257 7.70409 5.88681 7.15944 6.25073C6.61479 6.61466 6.19029 7.13192 5.93961 7.7371C5.68894 8.34229 5.62335 9.00822 5.75114 9.65068C5.87893 10.2931 6.19437 10.8833 6.65756 11.3465C7.12074 11.8097 7.71088 12.1251 8.35334 12.2529C8.9958 12.3807 9.66173 12.3151 10.2669 12.0644C10.8721 11.8137 11.3894 11.3892 11.7533 10.8446C12.1172 10.2999 12.3115 9.65959 12.3115 9.00454C12.3105 8.12646 11.9612 7.28463 11.3403 6.66373C10.7194 6.04283 9.87756 5.69357 8.99948 5.69257ZM8.99948 10.6605C8.67195 10.6605 8.35179 10.5634 8.07946 10.3814C7.80713 10.1995 7.59488 9.94086 7.46954 9.63826C7.34421 9.33567 7.31141 9.00271 7.37531 8.68148C7.43921 8.36024 7.59692 8.06518 7.82852 7.83358C8.06011 7.60199 8.35518 7.44427 8.67641 7.38037C8.99764 7.31648 9.33061 7.34927 9.6332 7.47461C9.93579 7.59995 10.1944 7.8122 10.3764 8.08452C10.5583 8.35685 10.6555 8.67702 10.6555 9.00454C10.655 9.44358 10.4803 9.8645 10.1699 10.1749C9.85943 10.4854 9.43852 10.66 8.99948 10.6605Z" fill="#AD0419" />
        <path d="M15.3639 2.63536C13.7903 1.06219 11.6898 0.127665 9.4677 0.0121464C7.24562 -0.103372 5.05952 0.608304 3.33131 2.00982C1.6031 3.41134 0.455294 5.40334 0.109424 7.60137C-0.236445 9.79941 0.244139 12.0476 1.45842 13.9122L7.71532 23.5176C7.85456 23.7313 8.04494 23.9069 8.2692 24.0285C8.49347 24.15 8.74452 24.2137 8.99962 24.2137C9.25471 24.2137 9.50576 24.15 9.73003 24.0285C9.95429 23.9069 10.1447 23.7313 10.2839 23.5176L16.541 13.9122C17.6677 12.1825 18.1657 10.1182 17.9513 8.06511C17.737 6.01202 16.8235 4.095 15.3639 2.63536ZM15.1535 13.0083L8.99964 22.4552L2.84573 13.0083C0.962041 10.1165 1.36605 6.24671 3.80636 3.8063C4.48834 3.12429 5.29798 2.5833 6.18905 2.2142C7.08011 1.8451 8.03516 1.65513 8.99964 1.65513C9.96413 1.65513 10.9192 1.8451 11.8102 2.2142C12.7013 2.5833 13.5109 3.12429 14.1929 3.8063C16.6332 6.24671 17.0372 10.1165 15.1535 13.0083Z" fill="#AD0419" />
      </svg>


    ),
    title: "Map Street",
    detail: globalJson.address,
  },
];

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const payload = {
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(payload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>Contact | Viva Drive car rental</title>
      </Helmet>
      <div className="container mx-auto mt-12">
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-12">
          <div className="mt-8 max-w-sm">
            <h2 className="text-4xl font-semibold">Get in Touch</h2>
            <p className="my-2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.
            </p>
            {/* <div className="flex space-x-2">
                <Link to="https://www.facebook.com" className="cursor-pointer">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="39"
                      height="39"
                      rx="19.5"
                      stroke="#07BEB8"
                    />
                    <path
                      d="M24.3525 21.375H21.7158V29.25H18.2002V21.375H15.3174V18.1406H18.2002V15.6445C18.2002 12.832 19.8877 11.25 22.4541 11.25C23.6846 11.25 24.9854 11.4961 24.9854 11.4961V14.2734H23.5439C22.1377 14.2734 21.7158 15.1172 21.7158 16.0312V18.1406H24.8447L24.3525 21.375Z"
                      fill="black"
                    />
                  </svg>
                </Link>
                <Link to="https://www.instagram.com" className="cursor-pointer">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="39"
                      height="39"
                      rx="19.5"
                      stroke="#07BEB8"
                    />
                    <path
                      d="M15.8377 27H12.5682V16.4883H15.8377V27ZM14.1854 15.082C13.1658 15.082 12.3221 14.2031 12.3221 13.1484C12.3221 12.1289 13.1658 11.2852 14.1854 11.2852C15.24 11.2852 16.0838 12.1289 16.0838 13.1484C16.0838 14.2031 15.24 15.082 14.1854 15.082ZM28.0369 27H24.8025V21.9023C24.8025 20.6719 24.7674 19.125 23.0799 19.125C21.3924 19.125 21.1463 20.4258 21.1463 21.7969V27H17.8768V16.4883H21.0057V17.9297H21.0408C21.4979 17.1211 22.5525 16.2422 24.1346 16.2422C27.4393 16.2422 28.0721 18.4219 28.0721 21.2344V27H28.0369Z"
                      fill="black"
                    />
                  </svg>
                </Link>
              </div> */}
            <div className="flex flex-col mt-6">
              <div className=" space-y-6">
                {contacts.map((contact) => (
                  <div
                    key={contact.id}
                    className="flex items-center space-x-4"
                  >
                    {/* Icon */}
                    <div className="flex items-center justify-center w-12 h-12 ">
                      {contact.icon}
                    </div>

                    {/* Text */}
                    <div>
                      <p className="text-gray-500 text-sm">{contact.title}</p>
                      <p className="text-gray-900 text-lg font-semibold">
                        {contact.detail}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div >
            <div className="py-4">

            </div>
            <form className="grid grid-cols-1 gap-6" onSubmit={sendEmail}>
              <label className="block">
                <Label>Full name</Label>
                <Input
                  placeholder="Example Doe"
                  type="text"
                  className="mt-1"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Label>Email address</Label>

                <Input
                  type="email"
                  placeholder="example@example.com"
                  className="mt-1"
                  value={getEmail}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Label>Message</Label>

                <Textarea
                  className="mt-1"
                  rows={6}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </label>
              <div>
                <ButtonPrimary type="submit" className="min-w-[200px]">
                  {loading ? (
                    <div className="flex justify-center items-center col-span-full">
                      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </ButtonPrimary>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="container py-16   space-y-16 lg:space-y-28"> <FAQ/></div>
    </div>
  );
};

export default PageContact;
